module.exports = __webpack_public_path__ + "img/cover.5c605de0.jpg";